import { render, staticRenderFns } from "./BoutonAjoutProduit.vue?vue&type=template&id=1e4c1113&"
import script from "./BoutonAjoutProduit.vue?vue&type=script&lang=js&"
export * from "./BoutonAjoutProduit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports